document.addEventListener('DOMContentLoaded', () => {
  // ボタン要素を選択
  const pageTopButton = document.querySelector('.js-pageTop') as HTMLElement;

  // ボタンがクリックされたときのイベントリスナーを追加
  pageTopButton.addEventListener('click', (event) => {
    // デフォルトのイベントをキャンセル（ページが突然上に移動するのを防ぐ）
    event.preventDefault();

    // ページの一番上にアニメーションを用いてスクロール
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // アニメーション効果を指定
    });
  });
});
